import React from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import Button from 'components/Button';
import SVG from 'components/SVG';
import Select from 'components/Select/desktop';
import InputDate from 'components/InputDate/desktop';

import compareSVG from 'features/reports/img/compare.svg';
import arrowSVG from 'features/reports/img/arrow.svg';
import upSVG from 'features/reports/img/up.svg';
import downSVG from 'features/reports/img/down.svg';

import { diffRangeItems } from 'features/reports/data';

import convertToAmericanFormat from 'shared/helpers/convertToAmericanFormat';

import './Table.scss';

const b = block('reports-table-general');

const Table = ({
  handleSetWithDiff,
  withDiff,
  onChangeDiffRange,
  values,
  onChangeEndDiffDate,
  onChangeBeginDiffDate,
  handleGetDiff,
}) => {
  const locale = useSelector(state => state.locale.locale);
  const { currency } = useSelector(state => state.auth);
  const { detail, diff } = useSelector(state => state.reports.statisticProvider);

  const makeItem = ({ title, prevValue, diffPercent, currentValue, needCurrency = true, isPercent }) => {
    return (
      <div className={b('table-tr')}>
        <div className={b('table-th')}>
          {title}
          {withDiff && prevValue && (
            <div className={b('table-th-diff')}>
              {prevValue === '0' ? (
                <p className={b('table-th-diff-value')}>{prevValue}</p>
              ) : (
                <>
                  <SVG className={b('table-th-diff-icon')} svgProps={{ svg: diffPercent > 0 ? upSVG : downSVG }} />
                  <p className={b('table-th-diff-percent', { green: diffPercent > 0 })}>{`${diffPercent}%`}</p>
                  <p className={b('table-th-diff-value')}>{convertToAmericanFormat(prevValue)}</p>
                </>
              )}
            </div>
          )}
        </div>
        <div className={b('table-td')}>
          <div className={b('table-td-amount')}>
            {currentValue}
            {isPercent && '%'}
          </div>
          {needCurrency && <div className={b('table-td-currency')}>{currency}</div>}
        </div>
      </div>
    );
  };

  return (
    <div className={b()}>
      <div className={b('update-time')}>
        {detail?.lastCalculateTime && `${locale.lastUpdateTime}: ${detail?.lastCalculateTime}`}
      </div>
      <div className={b('header')}>
        {locale.total}
        <div className={b('header-main')}>
          {withDiff && (
            <div className={b('diff')}>
              {values.activeDiffRange.name === 'manualCompare' && (
                <div className={b('diff-range')}>
                  <div className={b('date-input')}>
                    <InputDate
                      selected={values.diffDate.beginDate}
                      onChange={onChangeBeginDiffDate}
                      title={locale.from}
                      fontSize={12}
                    />
                  </div>
                  <div className={b('date-input')}>
                    <InputDate
                      selected={values.diffDate?.endDate}
                      onChange={onChangeEndDiffDate}
                      title={locale.to}
                      fontSize={12}
                    />
                  </div>
                </div>
              )}

              <div className={b('select')}>
                <Select
                  items={diffRangeItems[values.activeDay?.text || 'manualCompare']}
                  activeItem={values.activeDiffRange}
                  onChange={onChangeDiffRange}
                />
              </div>
            </div>
          )}
          <div className={b('button')}>
            <Button
              callBack={handleGetDiff}
              text={
                <div className={b('button-content')}>
                  <SVG className={b('button-icon')} svgProps={{ svg: compareSVG }} />
                  {locale.compare}
                </div>
              }
            />
          </div>
          {withDiff && (
            <div className={b('button')}>
              <Button
                callBack={() => handleSetWithDiff(false)}
                color="bordered"
                text={
                  <div className={b('button-content')}>
                    <SVG className={b('button-icon')} svgProps={{ svg: arrowSVG }} />
                    {locale.standardValues}
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
      <div className={b('table')}>
        <div className={b('wrapper')}>
          {makeItem({
            currentValue: detail?.betCount,
            diffPercent: diff?.betCountPercent,
            prevValue: diff?.betCount,
            title: locale.betCount,
            needCurrency: false,
          })}
          {makeItem({
            currentValue: detail?.betAmount,
            diffPercent: diff?.betAmountPercent,
            prevValue: diff?.betAmount,
            title: locale.betAmount,
          })}
          {makeItem({
            currentValue: detail?.winAmount,
            diffPercent: diff?.winAmountPercent,
            prevValue: diff?.winAmount,
            title: locale.winAmount,
          })}
        </div>
        <div className={b('wrapper', { bottom: true })}>
          {makeItem({
            currentValue: detail?.incomeAmount,
            diffPercent: diff?.incomeAmountPercent,
            prevValue: diff?.incomeAmount,
            title: locale.incomeAmount,
          })}
          {makeItem({
            currentValue: detail?.commissionBalance,
            diffPercent: diff?.commissionBalancePercent,
            prevValue: diff?.commissionBalance,
            title: locale.commissionBalance,
          })}
          {makeItem({
            currentValue: detail?.margin,
            diffPercent: diff?.marginPercent,
            prevValue: diff?.margin,
            title: locale.margin,
            needCurrency: false,
            isPercent: true,
          })}
        </div>
      </div>
    </div>
  );
};

Table.propTypes = {};

export default Table;
